export class AuthorizeService {
    _callbacks = [];
    _nextSubscriptionId = 0;
    _user = null;
    _isAuthenticated = false;

    async isAuthenticated() {
        const user = await this.getUser();
        return !!user;
    }

    async getUser() {
        if (this._user) {
            return this._user;
        }

        const user = await this.getUserData();
        return user.userProfileViewModel;
    }

    async signIn(authorizeViewModel) {
        try {
            const user = await this.login(authorizeViewModel);
            if (user.success) {
                this.updateState(user.userProfileViewModel);
                localStorage.setItem('UserType', user.userProfileViewModel.userType);
                if (user.userProfileViewModel.userType === 0)
                    localStorage.setItem('BalanceAndRemainingHours', `Balance : $${user.userProfileViewModel.balance}`);
                else
                    localStorage.setItem('BalanceAndRemainingHours', '');

                localStorage.setItem('ApplicationName', user.userProfileViewModel.applicationName);
                return this.success();
            } else {
                return this.error(user.message);
            }
        } catch (loginError) {
            console.log("Authentication error: ", loginError);
            return this.error(loginError);
        }
    }

    async signOut() {
        try {
            const logoutData = await this.logout();
            this.updateState(undefined);
            localStorage.clear();
            if (logoutData.success) {
                return this.success();
            } else {
                return this.error(logoutData.message);
            }            
        } catch (signOutError) {
            console.log("Signout error: ", signOutError);
        }
    }

    updateState(user) {
        this._user = user;
        this._isAuthenticated = !!this._user;
        this.notifySubscribers();
    }

    subscribe(callback) {
        this._callbacks.push({ callback, subscription: this._nextSubscriptionId++ });
        return this._nextSubscriptionId - 1;
    }

    unsubscribe(subscriptionId) {
        const subscriptionIndex = this._callbacks
            .map((element, index) => element.subscription === subscriptionId ? { found: true, index } : { found: false })
            .filter(element => element.found === true);
        if (subscriptionIndex.length !== 1) {
            throw new Error(`Found an invalid number of subscriptions ${subscriptionIndex.length}`);
        }

        this._callbacks.splice(subscriptionIndex[0].index, 1);
    }

    notifySubscribers() {
        for (let i = 0; i < this._callbacks.length; i++) {
            const callback = this._callbacks[i].callback;
            callback();
        }
    }

    error(message) {
        return { status: AuthenticationResultStatus.Fail, message };
    }

    success() {
        return { status: AuthenticationResultStatus.Success };
    }

    redirect() {
        return { status: AuthenticationResultStatus.Redirect };
    }

    static get instance() { return authService }

    async login(authorizeViewModel) {
        const response = await fetch('/account', {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(authorizeViewModel)
        });

        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            throw new Error(message);
        }

        const userData = await response.json();
        return userData;
    }

    async getUserData() {
        const response = await fetch('/account');
        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            if (response.status == 404) {
                console.log("GetUserData error: ", response.status);
            }

            if (response.status == 500 || response.status == 400) {
                console.log("GetUserData error: ", response.status);
            }
        }
        const userData = await response.json();
        return userData;
    }

    async logout() {
        const response = await fetch('/account/logout');
        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            if (response.status == 404) {
                console.log("GetUserData error: ", response.status);
            }

            if (response.status == 500 || response.status == 400) {
                console.log("GetUserData error: ", response.status);
            }
        }
        const logoutData = await response.json();
        return logoutData;
    }

    async getApplicationName() {
        const response = await fetch('Account/GetApplicationName', {
            method: 'get',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            throw new Error(message);
        }

        const appData = await response.json();
        return appData.applicationName;
    }
}


const authService = new AuthorizeService();

export default authService;

export const AuthenticationResultStatus = {
    Redirect: 'redirect',
    Success: 'success',
    Fail: 'fail'
};
